import React, { useState } from "react";
import DataSummaryTable from "../components/table/DataSummaryTable";
import { useGetWeeklySummaryQuery } from "../redux/service/modules/dashboard";
import { useLazyGetLazyWeeklySummaryQuery } from "../redux/service/modules/dashboard/lazzyQuery";

import Tooltip from '@mui/material/Tooltip';

const PublicationMissedTable = ({initialDateRange, filters}) => {
  const highlightRules = [
    {
      column: "in_2_weeks",
      condition: "equals",
      value: 0,
      backgroundColor: "#fff1f1",
      borderColor: "#FF0000",
      tooltip: "No Publication in 2 weeks"
    },
    {
      column: "in_5_weeks",
      condition: "between",
      value: [0, 2],
      backgroundColor: "#FFF8E7",
      borderColor: "#FFA500",
      tooltip: "Less than 2 Publications in 5 weeks"
    }
  ];

  const customCellRender = {
    productivity: (row) => {
      if (typeof row?.productivity === 'string' && (row.productivity.includes('-') || row.productivity == '0%')) {
        return 0;
      } else {
        return row?.productivity
      }
        
    },
  };

  const legend = [
    { color: "bg-red-500", label: "No Publication in 2 weeks" },
    { color: "bg-yellow-500", label: "Less than 2 Publications in 5 weeks" },
  ];

  const customFooterElm = (
    <div className="flex justify-between items-center pt-2">
      <div className="flex">
        {legend.map((item, index) => (
          <div key={index} className="flex items-center mr-4">
            <div className={`w-3 h-3 rounded-full ${item.color} mr-2`} />
            <span style={{fontSize: '12px'}}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const [exportToExcelQuery] = useLazyGetLazyWeeklySummaryQuery()
  return (
    <DataSummaryTable
      title="Publication Missed"
      initialDateRange={initialDateRange}
      queryHook={useGetWeeklySummaryQuery}
      customFooterElm={customFooterElm}
      maxRows={6}
      filters={filters}
      highlightRules={highlightRules}
      setHeaderHeight={"1.5rem"}
      exportToExcelQuery={exportToExcelQuery}
      customCellRender={customCellRender}
    />
  );
};

export default PublicationMissedTable;
